import { ShadowBox } from 'components/ShadowBox'
import React, { PropsWithChildren, useState } from 'react'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FormValues } from 'utils/type'
import { WithShortsTooltip } from './WithShortsTooltip'
import { CircularCheckbox } from 'components/CircularCheckbox'
import { Me } from 'service/user'
import { AIRecommendProductShortTitleType, LinkDetailType } from 'service/list'
import { isMobile } from 'react-device-detect'
import { PlanTag } from 'components/planTag'
import { PurchaseInfoGuideTooltip } from './PurchaseInfoGuideTooltip'
import classNames from 'classnames'
import { TemplateSelector } from './factor/template-selector'

import { PreviewTag } from 'components/tag/PreviewTag'
import useGetProductTemplate from 'hooks/query/useGetProductTemplate'
import { translatePlanName } from 'pages/product-video-editor/util'
import useTranslation from 'hooks/useTranslation'

interface WithShortFormCreateProps {
  watch: UseFormWatch<FormValues>
  control: Control<FormValues, any>
  setValue: UseFormSetValue<FormValues>
  userInfo: Me
  selectedLinks: LinkDetailType[]
}

export const WithShortFormCreate = ({
  watch,
  setValue,
  control,
  userInfo,
  selectedLinks,
}: PropsWithChildren<WithShortFormCreateProps>) => {
  const { t } = useTranslation()
  const { data: templateList } = useGetProductTemplate()
  const [withShortsStatus, setWithShortsStatus] = useState<boolean>(false)
  const [isOpenPurchaseInfoGuideModal, setIsOpenPurchaseInfoGuideModal] =
    useState<boolean>(false)
  const [subtitleFlag, setSubtitleFlag] = useState<number>(0)
  const [bgmFlag, setBgmFlag] = useState<number>(0)
  const [purchaseInfoFlag, setPurchaseInfoFlag] = useState<number>(0)

  const handleClickSubtitle = (value: number) => {
    // 들어오는 인자에 따라서 존재하는 상품의 subtitleFlag 전체를 변경해야함.
    const flag = value
    const products = watch('products')
    const newProducts = products.map((el) => {
      el.subtitleFlag = flag
      return el
    })
    setValue('products', newProducts)
    setSubtitleFlag(flag)
  }

  const handleClickBgmFlag = (value: number) => {
    // 들어오는 인자에 따라서 존재하는 상품의 bgmFlag 전체를 변경해야함.

    const flag = value
    const products = watch('products')
    const newProducts = products.map((el) => {
      el.bgmFlag = flag
      return el
    })

    setValue('products', newProducts)
    setBgmFlag(flag)
  }

  const handleClickPurchaseInfoFlag = (value: number) => {
    // 들어오는 인자에 따라서 존재하는 상품의 purchaseInfoFlag 전체를 변경해야함.
    const flag = value
    const products = watch('products')
    const newProducts = products.map((el) => {
      el.purchaseInfoFlag = flag
      return el
    })

    setValue('products', newProducts)
    setPurchaseInfoFlag(flag)
  }

  return (
    <ShadowBox
      className={classNames('', {
        'py-[40px]  md:w-[816px] relative': !isMobile,
        'py-[40px]  md:w-[816px] relative px-4': isMobile,
      })}
    >
      {watch('products.0.link') === '' && (
        <div className="py-[40px] px-[16px] md:w-[816px] w-full h-full bg-white absolute z-50 left-0 opacity-50"></div>
      )}
      <div className="flex w-full justify-center items-start gap-1">
        <p className="font-bold text-[#2E343D] text-[24px] ">
          {t('productVideoEditor.withShortFormCreate.mainTitle')}
        </p>
      </div>
      <div
        className={classNames('', {
          'flex-col items-start mt-4': isMobile,
          'flex gap-2 items-center mt-10': !isMobile,
        })}
      >
        <p className="text-[18px] font-bold">{t('productVideoEditor.withShortFormCreate.title')}</p>
        <div className="flex gap-2 items-center">
          {' '}
          <img
            src="assets/img/cash.png"
            alt="툴팁"
            className="  w-[17px] h-[20px]"
            onMouseOver={() => {}}
          />
          <span className="font-bold text-main ">{t('productVideoEditor.withShortFormCreate.cashRequired')}</span>
          <button
            className="px-4 py-2 bg-main rounded-[6px] font-bold text-white"
            type="button"
          >
            <a
              className="w-full h-full flex items-center justify-center" // 추가
              href={`${process.env.REACT_APP_URL}/shortform-price-guide?payment=true&close=true`}
              target="_blank"
              rel="noreferrer"
            >
              {t('productVideoEditor.withShortFormCreate.chargeCash')}
            </a>
          </button>
          <p className=" relative">
            {' '}
            <img
              src="assets/img/icon_tooltip.png"
              alt="툴팁"
              className="  w-[20px] h-[20px]"
              onMouseOver={() => {
                setWithShortsStatus((prev) => !prev)
              }}
              onMouseLeave={() => {
                setWithShortsStatus((prev) => !prev)
              }}
            />
            {withShortsStatus && (
              <WithShortsTooltip setWithShortsStatus={setWithShortsStatus} />
            )}
          </p>
        </div>
      </div>
      <div className="mt-[10px]">
        <div
          className={classNames('', {
            'flex gap-6 items-center bg-[#F6F8FB] rounded-[10px] px-4 py-2':
              !isMobile,
            'gap-6 items-center bg-[#F6F8FB] rounded-[10px] px-4 py-2 grid grid-cols-2':
              isMobile,
          })}
        >
          {selectedLinks.map((el, index) => (
            <Controller
              key={`whitShort_${index}`}
              render={({ field }) => (
                <>
                  <label className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      className="w-[18px] h-[18px]"
                      checked={watch(`products.${index}.withShort`) === 1}
                      onChange={() => {
                        setValue(
                          `products.${index}.withShort`,
                          watch(`products.${index}.withShort`) === 1 ? 0 : 1
                        )
                      }}
                    />
                    <span className="font-bold text-[18px]">
                      {t('productVideoEditor.withShortFormCreate.productShortForm', { index: index + 1 })}
                    </span>
                  </label>
                </>
              )}
              name={`products.${index}.withShort`}
              control={control}
              rules={{
                required: false,
              }}
            />
          ))}
        </div>
        <ul className=" list-disc text-[#5E6068] text-[14px] ml-5 mt-[10px]">
          <li>
            {t('productVideoEditor.withShortFormCreate.notices.cashConsumption')}
          </li>
          <li>
            {t('productVideoEditor.withShortFormCreate.notices.autoUpload')}
          </li>
          <li>
            {t('productVideoEditor.withShortFormCreate.notices.downloadLocation')}
          </li>
        </ul>
      </div>
      <div className="flex flex-col gap-10 mt-10">
        <div
          key="selectors"
          className="template_selector_box flex flex-col gap-10"
        >
          {selectedLinks.map((selectedLink, productIndex) => (
            <TemplateSelector
              watch={watch}
              setValue={setValue}
              control={control}
              translatePlanName={translatePlanName}
              userInfo={userInfo}
              templateList={templateList}
              productIndex={productIndex}
              basicTitle={selectedLink.title}
              selectedLink={selectedLink}
            />
          ))}
        </div>
        <div className="flex flex-col md:mb-[16px] gap-4 ">
          <p className="font-bold text-[18px]">{t('productVideoEditor.withShortFormCreate.subtitle.title')}</p>
          <div
            className={classNames('', {
              'grid grid-cols-2 ': !isMobile,
              'grid grid-cols-1 gap-y-3 ': isMobile,
            })}
          >
            {[
              { name: t('productVideoEditor.withShortFormCreate.subtitle.include'), value: 1 },
              { name: t('productVideoEditor.withShortFormCreate.subtitle.exclude'), value: 0 },
            ].map((el, index) => {
              return (
                <div key={index}>
                  <label className="flex gap-2 items-center">
                    <CircularCheckbox
                      onChange={(e) => {
                        handleClickSubtitle(el.value)
                      }}
                      id={index}
                      checked={el.value === subtitleFlag}
                      label={el.name}
                      disabled={
                        !userInfo || userInfo?.userType === 'normalUser'
                      }
                    />
                    {el.value === 1 && (
                      <div className="flex items-center gap-1">
                        {' '}
                        <div className="flex h-[21px] items-start   ">
                          <PlanTag planName={'PRO'} />
                        </div>
                        <span
                          className="text-[14px] font-bold w-[38px] h-[21px] text-[white] flex justify-center items-center rounded-[4px]"
                          style={{
                            background: `linear-gradient(to right,#9A60FF,#2580FF)`,
                          }}
                        >
                          βeta
                        </span>
                        <img
                          src="assets/img/gray_cash.png"
                          alt="툴팁"
                          className="  w-[17px] h-[20px]"
                        />
                        <span className="font-bold text-[#8F929B] text-[14px]">
                          {t('productVideoEditor.withShortFormCreate.subtitle.betaFree')}
                        </span>
                      </div>
                    )}
                  </label>
                </div>
              )
            })}
          </div>
        </div>
        <div className="flex flex-col md:mb-[16px] gap-4 ">
          <p className="font-bold text-[18px]">{t('productVideoEditor.withShortFormCreate.bgm.title')}</p>
          <div
            className={classNames('', {
              'grid grid-cols-2 ': !isMobile,
              'grid grid-cols-1 gap-y-3 ': isMobile,
            })}
          >
            {[
              { name: t('productVideoEditor.withShortFormCreate.bgm.include'), value: 1 },
              { name: t('productVideoEditor.withShortFormCreate.bgm.exclude'), value: 0 },
            ].map((el, index) => {
              return (
                <div key={index}>
                  <label>
                    <CircularCheckbox
                      onChange={(e) => {
                        handleClickBgmFlag(el.value)
                      }}
                      id={index}
                      checked={el.value === bgmFlag}
                      label={el.name}
                      disabled={
                        !userInfo || userInfo?.userType === 'normalUser'
                      }
                    />
                  </label>
                </div>
              )
            })}
          </div>
        </div>

        <div className="flex flex-col md:mb-[16px] gap-4 ">
          <p className="font-bold text-[18px] flex items-center gap-3 relative">
            {t('productVideoEditor.withShortFormCreate.purchaseGuide.title')}{' '}
            <PreviewTag setIsOpenModal={setIsOpenPurchaseInfoGuideModal} />
            {isOpenPurchaseInfoGuideModal && (
              <PurchaseInfoGuideTooltip
                setIsOpenPurchaseInfoGuideModal={
                  setIsOpenPurchaseInfoGuideModal
                }
              />
            )}
          </p>
          <div
            className={classNames('', {
              'grid grid-cols-2 ': !isMobile,
              'grid grid-cols-1 gap-y-3 ': isMobile,
            })}
          >
            {[
              { name: t('productVideoEditor.withShortFormCreate.purchaseGuide.include'), value: 1 },
              { name: t('productVideoEditor.withShortFormCreate.purchaseGuide.exclude'), value: 0 },
            ].map((el, index) => {
              return (
                <div key={index}>
                  <label>
                    <CircularCheckbox
                      id={index}
                      checked={el.value === purchaseInfoFlag}
                      label={el.name}
                      onChange={() => {
                        handleClickPurchaseInfoFlag(el.value)
                      }}
                    />
                  </label>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </ShadowBox>
  )
}
